<template>
  <modal class="modal-campings" v-if="show" @close="hide">
    <h3 slot="header">{{$resx('HomeChooseCampsiteText')}}</h3>
    <div slot="body">
      <ul>
        <li v-for="camping in campings" :key="camping.id">
          <a @click="selectCamping(camping)">{{camping.name}}</a>
        </li>
      </ul>
    </div>
  </modal>
</template>
<script>
import modal from './modal.vue'

export default {
  props: {
    show: Boolean
  },
  computed: {
    // liste des campings sélectionnable pour le groupe
    campings () {
      return this.$store.state.partner.account.campings
    }
  },
  methods: {
    // cacher la fentrer
    hide () {
      this.$emit('update:show', false)
    },

    // selectionner un camping
    selectCamping (item) {
      this.$store.commit('partner/selectCampsite', item)
      this.hide()
    }
  },
  components:
  {
    modal: modal
  }
}
</script>
<style lang="less">
  @import '../assets/variables.less';

  .modal-campings {

    .modal-container
    {
        max-width: 60em;
    }

    ul
    {
      column-count:2;
    }

    li
    {
      position:relative;
      color:@gold;
      font-size:1.25em;
      margin:.25em 0;

      a
      {
        text-decoration:underline;
        margin-left:20px;
        cursor:pointer;
      }

      &:before
      {
        content:'';
        display:inline-block;
        position:absolute;
        left:0;
        top:50%;
        width:.3em;
        height:.3em;
        border-radius:50%;
        background-color:@gold;
        transform:translateY(-50%);
      }
    }
  }
</style>
